import { Injectable } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class CustomFormValidatorService {
  constructor() {}

  public isInvalidField(form: FormGroup, field: string) {
    return form.controls[field].errors && form.controls[field].touched;
  }

  public isInvalidFieldInArray(
    formArray: FormArray,
    index: number,
    field: string
  ) {
    return (
      formArray.controls[index].get(field)?.errors &&
      formArray.controls[index].get(field)?.touched
    );
  }

  public isInvalidItemInArray(formArray: FormArray, index: number) {
    return (
      formArray.controls[index].errors && formArray.controls[index].touched
    );
  }

  public getFieldErrorInArray(
    formArray: FormArray,
    index: number,
    field: string
  ) {
    const fieldI = formArray.controls[index].get(field);
    if (!fieldI) {
      throw new Error("Invalid field on this form");
    }
    return this.getFieldErrorMsg(fieldI);
  }

  public getFieldError(form: FormGroup, field: string) {
    const fieldI = form.controls[field];
    if (!fieldI) {
      throw new Error("Invalid field on this form");
    }
    return this.getFieldErrorMsg(fieldI);
  }

  private getFieldErrorMsg(control: AbstractControl): string | null {
    const errors = control.errors || {};
    for (const key of Object.keys(errors)) {
      switch (key) {
        case "required":
          return "Este Campo es requerido";
        case "minlength":
          return `Mínimo ${errors["minlength"].requiredLength} caracteres`;
        case "maxlength":
          return `Máximo ${errors["maxlength"].requiredLength} caracteres`;
        case "min":
          return `Unicamente valores positivos`;
        case "max":
          return `Máximo ${errors["max"].max}`;
        case "atLeastOneElement":
          return `Utiliza al menos uno`;
        case "email":
          return "Ingresa un email válido";
        case "onlyNumbers":
          return "Solo se permiten números";
        case "todayForward":
          return "La sesión debe programarse para después de hoy de la hora actual en adelante";
        case "startTimeBigger":
          return "La hora de finalización debe ser posterior a la hora de inicio.";
        case "endDateBeforeStartDate":
          return "La fecha de inicio debe de ser anterior a la fecha de fin";
        case "pattern":
          return "El formato es inválido.";
        case "fileTypes":
          return "Únicamente se aceptan archivos de tipo imagen";
        case "fileSize":
          return `Únicamente se aceptan archivos de máximo ${
            errors["fileSize"][0].maxSize / 1000
          } Kb`;
        default:
          return `Error not found`;
      }
    }
    return null;
  }

  // Custom Validations
  atLeastOneElementOnArray: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const arrayField = control.value as any[];
    return arrayField && arrayField.length >= 1
      ? null
      : { atLeastOneElement: true };
  };

  onlyNumbers: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const onlyNumRegex = /^\d+$/;
    const arrayField = control.value as string;
    return arrayField && onlyNumRegex.test(arrayField)
      ? null
      : { onlyNumbers: true };
  };
  // biggerThan(
  //   form: FormGroup,
  //   biggerField: string,
  //   lowerField: string
  // ): ValidationErrors | null {
  //   const biggerFieldF = form.controls[biggerField];
  //   const lowerFieldF = form.controls[lowerField];
  //   return lowerField && biggerFieldF && biggerFieldF.value > lowerFieldF.value
  //     ? null
  //     : { mustBeBigger: true };
  // }
}
